import BaseTrigger from '@/../vendor/formvalidation-1.3.0/dist/es6/plugins/Trigger';

// Custom version of the default trigger plugin
// that ignores CustomEvent so that validations
// are run only on user changing the values
// not when they're programmatically changed
export default class Trigger extends BaseTrigger {
  handleEvent(e, field, ele) {
    // Only consider actual change events
    if (!(event instanceof CustomEvent)) {
      super.handleEvent(e, field, ele);
    }
  }
}



// WEBPACK FOOTER //
// ./app/webpack/javascripts/embed/form_validation/plugins/Trigger.js